import { filter, includes } from "lodash";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
// import {
//   deleteTractorDailyPlan,
//   deleteTractorMonthlyPlan,
// } from "../../../services/tractorDataService";
import { TRACTOR_BOOKING_LOADED } from "../../../store/ActionTypes";
import { dispatcher } from "../../../store/storeHelpers";
import AddTransporterModal from "../AddTransporterModal";
import TableColumnOrder from "../TableColumnOrder";
import {
  updateTractorBulkData,
  getDailyContainerPlanningAB,
} from "../../../services/tractorDataService";
import { tractorDataCreatorForStore } from "../../../utils/dataFilter";
import DeleteModal from "../DeleteModal";
import ModuleChangeModal from "../ModuleChangeModal";
import Tooltips from "../../Custom Components/tooltip";
import { deleteTractorShipmentById } from "../../../services/tractorDataService";
import { ChangeContainerDiversion } from "../../../services/dataService";
import FactoryOutCheckModal from "../FactoryOutCheckModal";
import BookingNumberCheckModal from "../BookingNumbeCheckModal";
import ContainerCheckModule from "../ContainerCheckModule";
import { getConatinerData } from "../../../services/dataService";
import { ErrorMsg } from "../../../utils/validator";
import ExportTractorPlan from "../Export-Excel/TractorPlanExportModal";
import { getContainerswapdata } from "../../../services/tractorDataService";
import { CONTAINER_SWAP_DATA } from "../../../store/ActionTypes";
import store from "../../../store/Store";

function TractorActionCenter({
  date,
  setDate,
  setShowCreateNewSchedule,
  setShowDailyPlanUploader,
  dataExportHandler,
  tableData,
  type,
  allColumns,
  getToggleHideAllColumnsProps,
  selectedMonth,
  newSelectedFlatRows,
  subModule,
  monthlyData,
  tractorTemplateFileExportHandler,
  filteredUserAccessData,
  globalFilter,
  setGlobalFilter,
  setCountData,
  setNoDataState,
}) {
  // const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showTransporterModal, setShowTransporterModal] = useState(false);
  const [bulkData, setBulkData] = useState([]);
  const [changeModuleData, setChangeModuleData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [showBookingCheckModal, setshowBookingCheckModal] = useState(false);
  const [ExportTractorMonthlyPlan, setExportTractorMonthlyPlan] =
    useState(false);
  const [deleteMsg, setDeleteMsg] = useState([]);
  const [changeMsg, setChangeMsg] = useState([]);
  const [ids, setIds] = useState("");
  const [checkedData, setCheckedData] = useState("");
  const [showFactoryOutModal, setFactoryOutModal] = useState(false);
  const [showContainerCheckModal, setConatinerCheckModal] = useState(false);
  const [data, setData] = useState([]);
  const [step, setstep] = useState(1);
  const [isloading, setisloading] = useState(false);

  var allowToAdd = filter(filteredUserAccessData, { Add: 1 }).length > 0;
  var allowToUpload = filter(filteredUserAccessData, { Upload: 1 }).length > 0;
  var allowToDelete = filter(filteredUserAccessData, { Delete: 1 }).length > 0;
  var allowToDownload =
    filter(filteredUserAccessData, { DownLoad: 1 }).length > 0;
  var allowToEdit = filter(filteredUserAccessData, { Edit: 1 }).length > 0;

  useEffect(() => {
    var planningId = [];
    var deleteList = "";
    var checkboxData = [];
    for (let i = 0; i < newSelectedFlatRows.length; i++) {
      if (newSelectedFlatRows[i].originalSubRows.length === 0) {
        if (!includes(planningId, newSelectedFlatRows[i].original)) {
          planningId.push(
            newSelectedFlatRows[i].original.DailyContainerPlanningId
          );
        }
        // }
      }
    }
    for (let j = 0; j < planningId.length; j++) {
      if (j !== planningId.length - 1) {
        deleteList += planningId[j] + ",";
      } else {
        deleteList += planningId[j];
      }
      setIds(deleteList);
    }

    for (let k = 0; k < newSelectedFlatRows.length; k++) {
      if (newSelectedFlatRows[k].originalSubRows.length === 0) {
        if (newSelectedFlatRows[k].original.Container_Count !== "") {
          if (!includes(checkboxData, newSelectedFlatRows[k].original)) {
            checkboxData.push(newSelectedFlatRows[k].original);
          }
        }
      }
    }
    setCheckedData(checkboxData);
  }, [newSelectedFlatRows]);

  const deletePlan = async () => {
    if (changeModuleData.length > 0) {
      if (subModule === "Daily") {
        // let datas = [];
        // try {
        //   const response = await deleteTractorShipmentById(ids, "No");
        //   datas.push(response.data.Message);
        //   setShowDeleteModal({ status: true, msg: response.data.Message });
        //   setDeleteMsg(datas);
        // } catch (error) {
        //   toast.error("Unable to  delete records...please try again");
        // }

        let datas = [];
        let err = [];

        for (let i = 0; i < changeModuleData.length; i++) {
          if (changeModuleData[i].IsFactoryOut === 1) {
            err.push(changeModuleData[i].Booking_Number);
          }
        }

        if (err.length > 0) {
          setFactoryOutModal({
            status: true,
            msg: ErrorMsg(err),
          });
        } else {
          if (ids) {
            datas.push("Are you really want to delete this records?");
            setShowDeleteModal({
              status: true,
              msg: "Are you really want to delete this records?",
            });
            setDeleteMsg(datas);
          } else {
            toast.error("Unable to  delete records...please try again");
          }
        }
      }
      if (subModule === "Monthly") {
        setShowDeleteModal({
          status: true,
          msg: "Are you sure you want to delete this record?",
        });
      }
    }
  };
  const changeModule = async () => {
    try {
      const payload = {
        date: date,
        type: "Tractor",
        screen:"DiversionFrom"
      };
      const response = await getContainerswapdata(payload);
      dispatcher(CONTAINER_SWAP_DATA, response?.data);
      setData(response?.data);
      setConatinerCheckModal({ status: true });
    } catch (e) {
      if (e.response?.data?.Message) {
        toast.error(e.response.data.Message);
      } else {
        toast.error("Something went wrong");
      }
    }

    /*   if (changeModuleData.length > 0) {
     
      const err = [];
      var finalChangeData = [];
      for (let i = 0; i < changeModuleData.length; i++) {
        if (changeModuleData[i].Booking_Number === null) {
          setshowBookingCheckModal({
            status: true,
            msg: "The selected rows contain missing booking numbers Please review your selection for diversion.",
          });
        } else {
          if (changeModuleData[i].IsFactoryOut === 0) {
            finalChangeData.push({
              DailyContainerPlanningId: Number(
                changeModuleData[i].DailyContainerPlanningId
              ),
              Booking_Number: changeModuleData[i].Booking_Number,
              Type: "Tractor",
            });

            try {
              const response = await getConatinerData(finalChangeData);

              setData(response.data); */

    /*   } catch (error) {
              toast.error("Container data not available for diversion");
            }
          } else {
           
            err.push(changeModuleData[i].Booking_Number);
          } */
        }
      
     /*  if(err.length  > 0 ){ 
        setFactoryOutModal({
          status: true,
    msg:`The container for this (${err})  booking has already been mark as "factory gate out" therefore, it cannot be diverted.` */
 



  useEffect(() => {
    var _jsonTracBookingUpList = [];

    for (let i = 0; i < newSelectedFlatRows.length; i++) {
      if (newSelectedFlatRows[i].originalSubRows.length === 0) {
        if (newSelectedFlatRows[i].original.Container_Count !== "") {
          if (
            !includes(_jsonTracBookingUpList, newSelectedFlatRows[i].original)
          ) {
            _jsonTracBookingUpList.push(newSelectedFlatRows[i].original);
          }
        }
      }
    }
    setBulkData(_jsonTracBookingUpList);
    setChangeModuleData(_jsonTracBookingUpList);
  }, [newSelectedFlatRows]);

  function addTransporterHandler() {
    setShowTransporterModal(true);
  }
  function ExportPlanHandler() {
    setExportTractorMonthlyPlan(true);
  }

  async function bulkClickHandlers() {
    var finalData = [];
    if (bulkData.length > 0) {
      for (let i = 0; i < bulkData.length; i++) {
        finalData.push({
          DailyContainerPlanningId: bulkData[i].DailyContainerPlanningId,
          Transporter: bulkData[0].Transporter,
          Port_Of_Destination: bulkData[0].Port_Of_Destination,
          BookingDocument: bulkData[0].BookingDocument,
          Container_Type: bulkData[0].Container_Type,
          SI: bulkData[0].SI,
          Remark: bulkData[0].Remark,
          VSL_VOY: bulkData[0].VSL_VOY,
          final_destination: bulkData[0].final_destination,
          ETA: bulkData[0].ETA,
          ETD: bulkData[0].ETD,
          Carrier: bulkData[0].Carrier,
          // Factory_In_Date: bulkData[0].Factory_In_Date,
          // Factory_Out_Date: bulkData[0].Factory_Out_Date,
          JD_Stuffing_Date: bulkData[0].JD_Stuffing_Date,
          Ground_Rent_Days: parseInt(bulkData[0].Ground_Rent_Days),
          Origin_Transit_Time: parseInt(bulkData[0].Origin_Transit_Time),
          Approx_container_detention: parseInt(
            bulkData[0].Approx_container_detention
          ),
          Market: bulkData[0].Market,
        });
      }
    }
    try {
      await updateTractorBulkData(finalData);
      const response = await getDailyContainerPlanningAB(
        moment(date).format("YYYY-MM-DD")
      );

      dispatcher(
        TRACTOR_BOOKING_LOADED,
        tractorDataCreatorForStore(response.data.Resultset1)
      );
      toast.success("Tractor data updated");
    } catch (error) {
      toast.error("something went wrong...please try again");
    }
  }
  return (
    <>
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          hide={() => setShowDeleteModal(false)}
          label="delete plan"
          dataType="Tractor"
          type={type}
          date={date}
          selectedMonth={selectedMonth}
          tableData={tableData}
          monthlyData={monthlyData}
          datas={deleteMsg}
          setCountData={setCountData}
          checkedData={checkedData}
          ids={ids}
          setNoDataState={setNoDataState}
        />
      )}
      {showChangeModal && (
        <ModuleChangeModal
          showModal={showChangeModal}
          hide={() => setShowChangeModal(false)}
          label="change Module"
          dataType="Tractor"
          type={type}
          date={date}
          selectedMonth={selectedMonth}
          tableData={tableData}
          monthlyData={monthlyData}
          datas={changeMsg}
          setCountData={setCountData}
          checkedData={checkedData}
          ids={ids}
          button1="Aggregate"
          button2="5M"
          setNoDataState={setNoDataState}
          changeModuleData={changeModuleData}
        />
      )}
      {showFactoryOutModal && (
        <FactoryOutCheckModal
          showModal={showFactoryOutModal}
          hide={() => setFactoryOutModal(false)}
          label="change Module"
          dataType="Tractor"
          type={type}
          date={date}
          selectedMonth={selectedMonth}
          tableData={tableData}
          monthlyData={monthlyData}
          datas={changeMsg}
          setCountData={setCountData}
          checkedData={checkedData}
          ids={ids}
          button="ok"
          setNoDataState={setNoDataState}
          changeModuleData={changeModuleData}
        />
      )}
      {showContainerCheckModal && (
        <ContainerCheckModule
          showModal={showContainerCheckModal}
          hide={() => {
            setConatinerCheckModal(false);
            setstep(1);
          }}
          label="change Module"
          dataType="Tractor"
          type={type}
          date={date}
          selectedMonth={selectedMonth}
          tableData={data}
          monthlyData={monthlyData}
          datas={changeMsg}
          setCountData={setCountData}
          checkedData={checkedData}
          ids={ids}
          button="ok"
          setNoDataState={setNoDataState}
          changeModuleData={changeModuleData}
          changeModule={changeModule}
          setData={setData}
          step={step}
          setstep={setstep}
          isloading={isloading}
          setisloading={setisloading}
        />
      )}
       {ExportTractorMonthlyPlan && (
        <ExportTractorPlan
        show={ExportTractorMonthlyPlan}
        dataType="Tractor"
        dataExportHandler={dataExportHandler}
        onHide={() => setExportTractorMonthlyPlan(false)}
        setShowDailyPlanUploader
        />)}
        
     
      {showBookingCheckModal && (
        <BookingNumberCheckModal
          showModal={showBookingCheckModal}
          hide={() => setshowBookingCheckModal(false)}
          label="change Module"
          dataType="Tractor"
          type={type}
          date={date}
          selectedMonth={selectedMonth}
          tableData={tableData}
          monthlyData={monthlyData}
          datas={changeMsg}
          setCountData={setCountData}
          checkedData={checkedData}
          ids={ids}
          button="ok"
          setNoDataState={setNoDataState}
          changeModuleData={changeModuleData}
        />
      )}
      <AddTransporterModal
        show={showTransporterModal}
        onHide={() => setShowTransporterModal(false)}
      />
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          hide={() => setShowDeleteModal(false)}
          label="delete plan"
          dataType="Tractor"
          type={type}
          date={date}
          selectedMonth={selectedMonth}
          tableData={tableData}
          monthlyData={monthlyData}
          datas={deleteMsg}
          setCountData={setCountData}
          checkedData={checkedData}
          ids={ids}
          setNoDataState={setNoDataState}
        />
      )}
      {modalShow && (
        <TableColumnOrder
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
      <div className="flex-row-align-center">
        {type !== "month" && (
          <Form.Control
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="hiden-inp"
            placeholder="search here.."
            style={{ width: "100%" }}
          />
        )}
        {type !== "month" && (
          <Form.Group style={{ marginLeft: "12px" }}>
            <Form.Control
              type="date"
              className="hiden-inp"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={{ width: "100%" }}
            />
          </Form.Group>
        )}
        {/* {includes(user.role, "ata_pune") && ( */}
        <>
          {/* <Button
              className="btn btn-sm btn-tbl"
              onClick={() => setShowCreateNewSchedule(true)}
            >
              Create schedule
            </Button> */}
          {allowToUpload && subModule !== "Weekly" && (
            <Tooltips content={"Upload Plan"} direction="down">
              <button
                type="button"
                className="tractorActionCenter__upload"
                onClick={() => setShowDailyPlanUploader(true)}
              >
                <i
                  class="bx bx-upload"
                  // style={{ transform: "scale(1.5)" }}
                ></i>
              </button>
            </Tooltips>
          )}
          {type !== "month" && subModule !== "Weekly" && allowToDownload && (
            <Tooltips content={"Export"} direction="down">
              <button
                type="button"
                className="tractorActionCenter__upload"
                onClick={ExportPlanHandler}
              >
                <svg
                  viewBox="0 0 512 512"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#000000"
                >
                  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                  <g
                    id="SVGRepo_tracerCarrier"
                    stroke-linecap="round"
                    strokeLinejoin="round"
                  ></g>
                  <g id="SVGRepo_iconCarrier">
                    <g
                      id="Page-1"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Combined-Shape"
                        fill="#ffffff"
                        transform="translate(64.000000, 48.915055)"
                      >
                        <path d="M170.666667,36.418278 L170.666667,79.0849447 L42.6666667,79.0849447 L42.6666667,356.418278 L341.333333,356.418278 L341.333333,228.418278 L384,228.418278 L384,399.084945 L0,399.084945 L0,36.418278 L170.666667,36.418278 Z M313.751611,0 L414.169889,100.418278 L313.751611,200.836556 L283.581722,170.666667 L332.485,121.751 L277.333333,121.751611 C243.249474,121.751611 215.388568,148.395237 213.441977,181.991125 L213.333333,185.751611 L213.333333,292.418278 L170.666667,292.418278 L170.666667,185.751611 C170.666667,128.391511 215.942543,81.6061582 272.706355,79.1834943 L277.333333,79.0849447 L332.484,79.084 L283.581722,30.1698893 L313.751611,0 Z"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
            </Tooltips>
            // <Button
            // 	className="btn btn-sm btn-tbl"
            // 	onClick={() => dataExportHandler()}
            // >
            // 	Export <i class="bx bx-download"></i>
            // </Button>
          )}
          {subModule === "Daily" && allowToDownload && (
            <Tooltips content={"Download Template"} direction="down">
              <button
                type="button"
                className="tractorActionCenter__upload"
                onClick={() => tractorTemplateFileExportHandler()}
              >
                <i class="bx bx-download"></i>
              </button>
            </Tooltips>
            // <Button
            // 	className="btn btn-sm btn-tbl"
            // 	onClick={() => tractorTemplateFileExportHandler()}
            // >
            // 	Template
            // 	<i class="bx bx-download" style={{ transform: "scale(1.3)" }}></i>
            // </Button>
          )}
          {subModule === "Daily" && allowToEdit && (
            <Tooltips content={"Update Bulk Data"} direction="down">
              <button
                className="tractorActionCenter__BulkData"
                onClick={bulkClickHandlers}
                disabled={newSelectedFlatRows.length === 0}
              >
                <i
                  class="bx bxs-select-multiple"
                  // style={{ transform: "scale(1.2)", marginTop: "7px" }}
                ></i>
              </button>
            </Tooltips>
          )}

          {/* {includes(user.role, "deleteAccess") && (
              <> */}
          {allowToDelete && subModule !== "Weekly" && (
            <Tooltips content={"Delete Plan"} direction="down">
              <button
                className="tractorActionCenter__delete"
                variant="danger"
                onClick={deletePlan}
                id="tractorBulkDelete"
                disabled={
                  subModule === "Daily"
                    ? tableData.length === 0
                      ? true
                      : false
                    : false
                }
              >
                <i class="bx bxs-trash"></i>
              </button>
            </Tooltips>
          )}
          {/* </>
            )} */}

          {/* {includes(user.role, "addTransporter") && ( */}
          {allowToAdd && type !== "month" && subModule !== "Weekly" && (
            <Tooltips content={"Add Transporter"} direction="down">
              <button
                className="tractorActionCenter__addTransporter"
                onClick={addTransporterHandler}
              >
                <i class="bx bx-plus-medical"></i>
              </button>
            </Tooltips>
          )}
          {/* )} */}
        </>
        {/* )} */}
        {allowToAdd && type !== "month" && subModule !== "Weekly" && (
          <Tooltips content={"Change Module"} direction="down">
            <button
              className="tractorActionCenter__changeModule"
              onClick={changeModule}
              disabled={
                subModule === "Daily"
                  ? tableData.length === 0
                    ? true
                    : false
                  : false
              }
            >
              <i class="bx bx-transfer-alt"></i>
            </button>
          </Tooltips>
        )}
        {type !== "month" && subModule !== "Weekly" && (
          <Tooltips content={"Column Filter"} direction="down">
            <button
              className="tableColumnFilter_btn "
              onClick={() => setModalShow(true)}
            >
              <i class="bx bx-columns tableColumnFilter"></i>
            </button>
          </Tooltips>
        )}
      </div>
    </>
  );
}

export default TractorActionCenter;
